module.exports = __webpack_public_path__ + "static/img/code-of-life-3.2de5cd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/code-of-life-3.jpg
// module id = 6pEB
// module chunks = 1